import React from 'react'
import { useFormContext } from 'react-hook-form'
import { connect } from 'react-redux'
import { ThemeProvider } from 'styled-components'
import { ErrorMessage } from '@hookform/error-message'

import { TagPushCarousel } from 'analytics/carousel'

import { ValidationError } from 'components/ValidationError'
import { CurrencyValueInput, InputField, NumberInput } from 'components/Input'
import { PatSwitch } from 'components/SwitchButton'

import ProductFormItem from './ProductFormItem'

import { addEditProduct, openModal } from 'store/actions/cart'

import {
    Form,
    FormContent,
    FormTitle,
    FormHeader,
    FormFields,
    FormBody,
    FormColumn,
    FormRow,
    ErrorMessageContainer,
    Button,
    Label,
    FormTitles
} from './ProductFormLayout.style'

const ProductFormLayout = ({
    product,
    groups,
    onSwitchChange,
    cartProductInfo,
    addEditProduct,
    openCartMenu
}) => {
    const { watch, handleSubmit } = useFormContext()

    const isPatChecked = watch('isPat')

    const onSubmit = (data) => {
        TagPushCarousel.addToCart({
            ...product,
            value: data.monthlyValue,
            quantity: data.cardQuantity
        })
        const groupsData = {
            items: Object.keys(data.groups).map((key) => ({
                type: key,
                value: data.groups[key].monthlyValue ?? '',
                qnt: data.groups[key].cardQuantity ?? '',
                total: data.groups[key].total ?? 0.0,
                adminstrationTax: data.groups[key].adminstrationTax ?? 0.0,
                feeType: data.groups[key].feeType ?? 'PERCENTAGE',
                totalFee: data.groups[key].totalFee ?? 0.0
            })),
            total: product.groups.total ?? 0.0,
            totalFee: product.groups.totalFee ?? 0.0
        }

        addEditProduct({
            id: product.id,
            qnt: data.cardQuantity,
            value: data.monthlyValue,
            groups: groupsData,
            isPat: data.isPat,
            loading: false
        })
        openCartMenu()
    }

    return (
        <form noValidate autoComplete="off" onSubmit={handleSubmit(onSubmit)}>
            <Form>
                <FormContent>
                    <FormHeader>
                        <FormTitle $color={product.color}>
                            Defina a quantidade de cartões {product.name} e o
                            valor mensal por cartão
                        </FormTitle>
                        <FormFields>
                            <FormColumn className="card-quantity">
                                <Label htmlFor="cardQuantity">
                                    Qnt. de cartões {product.name}
                                </Label>
                                <InputField
                                    as={NumberInput}
                                    tooltipErrors
                                    id="cardQuantity"
                                    name="cardQuantity"
                                    type="tel"
                                    aria-label={`Quantidade de cartões ${product.name}`}
                                    mask={[
                                        { mask: Number, min: 0, max: 50000 }
                                    ]}
                                    unmask="typed"
                                />
                            </FormColumn>
                            <FormColumn className="card-value">
                                <Label htmlFor="cardValue">
                                    Valor mensal por cartão
                                </Label>
                                <InputField
                                    as={CurrencyValueInput}
                                    tooltipErrors
                                    decimalSeparator=","
                                    thousandSeparator="."
                                    prefix="R$ "
                                    inputType="tel"
                                    maxLength={13}
                                    id="monthlyValue"
                                    name="monthlyValue"
                                    type="tel"
                                    aria-label="Valor mensal por cartão"
                                    defaultValue={watch('monthlyValue') ?? ''}
                                />
                            </FormColumn>
                        </FormFields>
                    </FormHeader>
                    <FormBody>
                        <FormRow>
                            <span>
                                Escolha os benefícios e distribua de acordo com
                                a quantidade de cartões informada acima:
                            </span>
                            <PatSwitch
                                name="isPat"
                                onChange={onSwitchChange}
                                defaultValue={isPatChecked}
                            />
                        </FormRow>
                        <FormTitles>
                            <Label $pos={3} $color={product.color}>
                                Qtde de colaboradores
                            </Label>
                            <Label $pos={4} $color={product.color}>
                                Valor mensal por colaborador
                            </Label>
                        </FormTitles>
                        <ThemeProvider theme={{ home: true }}>
                            {groups.map((group, index) => (
                                <ProductFormItem
                                    key={group.type}
                                    product={product}
                                    group={group}
                                    index={index}
                                    withTooltip
                                />
                            ))}
                        </ThemeProvider>
                        <ErrorMessageContainer>
                            <ErrorMessage
                                name="sumCardQuantity"
                                render={({ message }) => (
                                    <ValidationError>{message}</ValidationError>
                                )}
                            />
                        </ErrorMessageContainer>
                    </FormBody>
                </FormContent>
                <Button id={`btnAdd${product.id}Cart`} type="submit" kind="add">
                    {cartProductInfo ? 'Atualizar cesta' : 'Ver quanto custa'}
                </Button>
            </Form>
        </form>
    )
}

const mapDispatchToProps = (dispatch) => ({
    addEditProduct: (product) => dispatch(addEditProduct(product)),
    openCartMenu: () => dispatch(openModal())
})

export default connect(null, mapDispatchToProps)(ProductFormLayout)
